import React, { Component } from "react";
// import { Container, Row, Col } from "react-bootstrap";
import CreateProjectForm from "./CreateProjectForm";
import CreateProjectSidebar from "./CreateProjectSidebar";

export class CreateProject extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="content">
          <div className="create-project-wrapper">
            <CreateProjectForm />
          </div>
        </div>
        <div className="right-sidebar">
          <div className="right-sidebar-inner">
            <CreateProjectSidebar />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CreateProject;
